import baseAttributes from '../__data/base/data-attributes.json'

export const injectDataAttributes = (key: string): Record<string, string> => {
  return key?.split('.')
    .reduce((acc, val) => {
      return acc ? acc[val] : undefined
    }, baseAttributes) as unknown as Record<string, string>
}

export const injectDataAttributesByField = (path: string): Record<string, string> => {
  return injectDataAttributes(`fields.${path}`)
}
